import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { updateTableData } from '../Helper/SliceDataHelper';

import { IPropertyHistory } from '../../../types';
import { ERecordLength } from '../../data/Constants';
import { PropertyHistoryApi } from '../../api/PropertyHistoryApi';
import { IReadPropertyHistoryRequest } from '../../../types/IRequestTypes';

const initialState: IPropertyHistory = {
  data: {},
  totalCount: 0,
  currentPage: 1,
  recordsPerPage: ERecordLength.RL15,
  requestPayload: {},
};

//Feature thunks
//To get the paginated Feature data
export const getPropertyHistoryData = createAsyncThunk(
  '/history/v1/propertiesassociation/read',
  async (propertyHistoryrequest: IReadPropertyHistoryRequest) => {
    return await PropertyHistoryApi.fetchPropertyHistoryData(propertyHistoryrequest);
  }
);

const propertyHistorySlice = createSlice({
  name: 'propertyHistory',
  initialState: initialState,
  reducers: {
    // Reset property history state to initial defaults
    resetPropertyHistory: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getPropertyHistoryData.fulfilled, (state, action) => {
      if (!('error' in action.payload)) {
        return updateTableData(state, action.payload, action.meta.arg);
      }
      return state;
    });
  },
});

export const { resetPropertyHistory } = propertyHistorySlice.actions;
export default propertyHistorySlice.reducer;
